const Exchanges = () => {
	return <h1>Working Coming soon...</h1>;
};

export default Exchanges;
